<template>
  <div id="app-login">
    <form class="form-signin" @submit.prevent="newPassword()">
      <h1 class="h3 mb-3 font-weight-normal">Kies een wachtwoord</h1>
      <label for="inputPassword" class="sr-only">Nieuw wachtwoord</label>
      <input
        v-model="user.wachtwoord"
        type="password"
        class="form-control"
        placeholder="Nieuw wachtwoord"
        required
      />
      <input
        v-model="user.herhaalwachtwoord"
        type="password"
        class="form-control"
        placeholder="Herhaal wachtwoord"
        required
      />

      <p v-html="wachtwoordFeedback">{{ wachtwoordFeedback }}</p>

      <button class="btn btn-lg btn-primary btn-block" type="submit">Verander wachtwoord</button>
    </form>
  </div>
</template>

<script>
//import $ from "jquery";
import "bootstrap";
import axios from "axios";

export default {
  name: "app",
  components: {},
  data() {
    return {
      user: {
        herhaalwachtwoord: "",
        wachtwoord: "",
      },
      wachtwoordFeedback: "",
    };
  },
  created() {},
  mounted() {},
  methods: {
    newPassword() {
      if (this.user.wachtwoord == this.user.herhaalwachtwoord) {
        axios
          .post("https://hofman.weblion.be/api/gebruikers/reset_pass.php", {
            pass: this.user.wachtwoord,
            reset: this.$route.query.r,
          })
          .then((res) => {
            if (res) {
              this.$router.push({ path: "/login" });
            } else {
              this.wachtwoordFeedback =
                "Er ging iets fout. Probeer later nog eens om je wachtwoord opnieuw in te stellen.";
            }
          })
          .then(function () {});
      } else {
        this.wachtwoordFeedback =
          "De opgegeven wachtwoorden komen niet overeen. Probeer het nogmaals.";
      }
    },
  },
};
</script>

<style>
#app-login {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.form-signin {
  width: 100%;
}

.form-signin input {
  margin-bottom: 5px;
}

.help {
  margin-top: 15px;
  text-align: center;
}
</style>
